<template>
  <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
    <v-sheet class="transactionTable contestTable" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
      <v-data-table :items-per-page="10" :headers="headers" :items="formattedParticipants">
        <template v-slot:item.rank="{ item }">
          <span :class="getRankColorClass(item.rank)">
            {{ formatRank(item.rank) }}
          </span>
        </template>

        <template v-slot:item.profileLink="{ item }">
          <div class="flexbox">
            <v-avatar size="47">
              <v-img
                :src="item?.profile_pic_url || require('@/assets/contestprofile.png') || `https://ui-avatars.com/api/?name=${item?.participant_name}&background=random`"
                class="profile-image"></v-img>
            </v-avatar>
            <router-link class="custom-link" :to="`/registered-user-details/${item.client_id}`">
              {{ item.participant_name }}
            </router-link>
          </div>
        </template>

        <template v-slot:item.total_profit="{ item }">
          {{ formatProfit(item.total_profit) }}
        </template>

        <template v-slot:item.gain_percentage="{ item }">
          {{ item.gain_percentage }}%
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
export default {
  name: 'FinishedDataTable',

  props: {
    participants: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data() {
    return {
      headers: [
        { text: "Rank", value: "rank" },
        { text: "Name", value: "profileLink" },
        { text: "Account no", value: "account_no" },
        { text: "Profit", value: "total_profit" },
        { text: "Gain", value: "gain_percentage" }
      ]
    }
  },

  computed: {
    formattedParticipants() {
      return this.participants.map(participant => ({
        ...participant,
        profileLink: participant.participant_name
      }))
    }
  },

  methods: {
    getRankColorClass(rank) {
      if (rank === 1) return 'text--green rank'
      if (rank === 2) return 'text-warning rank'
      if (rank === 3) return 'text-orange rank'
      return 'text-gray rank'
    },

    formatRank(rank) {
      return rank.toString().padStart(2, '0')
    },

    getProfileImage(item) {
      try {
        return item.profile_pic_url || require(`@/assets/contest-${item.rank}.png`)
      } catch (e) {
        return `https://ui-avatars.com/api/?name=${item?.participant_name}&background=random`
      }
    },

    formatProfit(profit) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(profit)
    }
  }
}
</script>